var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddMoneyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 7.25244C2.4 5.26422 4.01178 3.65244 6 3.65244H10.5035C11.3872 3.65244 12.1035 4.36879 12.1035 5.25244V7.89307C12.1035 8.77672 11.3872 9.49307 10.5035 9.49307H4C3.11634 9.49307 2.4 8.77672 2.4 7.89307V7.25244Z",
    stroke: "white",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 14.4014C2.4 13.5177 3.11634 12.8014 4 12.8014H20C20.8837 12.8014 21.6 13.5177 21.6 14.4014V17.6067C21.6 19.5949 19.9882 21.2067 18 21.2067H6C4.01177 21.2067 2.4 19.5949 2.4 17.6067V14.4014Z",
    stroke: "white",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 4.39307C14.9 3.50941 15.6163 2.79307 16.5 2.79307H20C20.8837 2.79307 21.6 3.50941 21.6 4.39307V7.89307C21.6 8.77672 20.8837 9.49307 20 9.49307H16.5C15.6163 9.49307 14.9 8.77672 14.9 7.89307V4.39307Z",
    stroke: "white",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8496 7.50641C17.8496 7.72732 18.0287 7.90641 18.2496 7.90641C18.4705 7.90641 18.6496 7.72732 18.6496 7.50641V6.54313H19.613C19.8339 6.54313 20.013 6.36404 20.013 6.14313C20.013 5.92221 19.8339 5.74313 19.613 5.74313H18.6496V4.77988C18.6496 4.55897 18.4705 4.37988 18.2496 4.37988C18.0287 4.37988 17.8496 4.55897 17.8496 4.77988V5.74313H16.8863C16.6654 5.74313 16.4863 5.92221 16.4863 6.14313C16.4863 6.36404 16.6654 6.54313 16.8863 6.54313H17.8496V7.50641Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMoneyIcon);
export default __webpack_public_path__ + "static/media/add-money-icon.6aa0553463f7407be2ceec81caf01736.svg";
export { ForwardRef as ReactComponent };